import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const SubDepRemovalNotifCover = ({ notification }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={
        rtl
          ? `لقد تم حذفك من أعضاء قسم فرعى`
          : 'You have been removed from a Sub-department'
      }
    />
  )
}

export default SubDepRemovalNotifCover
